/* eslint-disable no-dupe-keys */
export default {
  evcs_operator: {
    name: '第三方平台商',
    // 属性（一般与对象内容匹配）
    prop: {
      operator_id: '组织机构代码',
      operator_name: '名称',
      ecmp_operator_id: '我方组织机构代码',
      ecmp_operator_name: '我方运营商名称',
      qr_code_identification: '二维码标识规则',
      protocol: '通讯协议',
      attr_naming_convention: '属性命名规则',
      order_accessible_scope: '订单访问范围',
      request_with_token: '需要Token',
      is_encrypted_data: '参数加密',
      protocol_tag: '协议标签',
      is_merging_equipment: '合并接口设备',
      operator_reg_address: '注册地址',
      operator_info: '第三方提供的服务',
      my_operator_info: '我方提供的服务',
      operator_tel1: '联系电话1',
      operator_tel2: '联系电话2',
      electric_decimal_places: '电量小数位数',
      operator_note: '备注',
      created_at: '创建时间',
      updated_at: '更新时间',
      station_service_fee_format: '电站服务费格式',
      station_electricity_fee_format: '电站电费格式',
      station_operator_id_source: '站OperatorId来源',
      balance: '余额',
      status: '状态',
      apis_count: '接口数',
      stations_count: '电站数',
      latest_query_at: '站访问',
      order_cancelable: '支持订单撤单',
      extra_info_province_code: '省份平台编码',
      extra_info_operator_pic_url: '服务平台运营商的企业营业执照url',
      extra_info_equipment_owner_pic_url: '设备所属方企业营业执照url',
      extra_info_operator_unified_social_credit_identifier: '服务平台的运营商统一社会信用码',
      extra_info_operator_name: '服务平台的运营商名称',
      extra_info_operator_id: '组织机构代码'
    },
    // Enum的属性
    protocols: {
      evcs: '中电联标准协议',
      cspg: '广东南方协议'
    },
    order_cancelables: {
      true: '可撤单',
      false: '不可撤单'
    },
    attr_naming_conventions: {
      upcase: '大写开头',
      downcase: '小写开头'
    },
    order_accessible_scopes: {
      evcs_order: '交换电订单',
      all_order: '所有订单'
    },
    config_statuses: {
      enabled: '启用',
      disabled: '禁用'
    },
    station_operator_id_sources: {
      from_ecmp_operator: '平台商的我方组织机构',
      from_service_provider: '站归属运营商的组织机构'
    },
    // Boolean的属性
    request_with_tokens: { true: '是', false: '否' },
    is_encrypted_datas: { true: '是', false: '否' },
    is_merging_equipments: { true: '是', false: '否' },
    // 占位提示
    placeholder: {
      search_keyword: '查询组织机构代码/名称/注册地址/备注',
      input_operator_id: '组织机构代码长度为9位',
      input_qr_code_identification: '如果二维码包含该信息，则通过该平台商启动',
      select_fee_format: '我方 query_stations_info 的站费率格式',
      input_protocol_tag: '支持 zhuhai/xindiantu/...'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      communicate_config: '入网配置',
      open_api: '开放API',
      debugger: '调试'
    },
    debuggers: {
      api_test_title: 'API 请求测试',
      service_detection: '服务及配置检测',
      communicate_config_type: '服务提供方',
      api_base_url: '服务的 URL',
      api_uri: 'API',
      api_params: '请求参数',
      api_response: '请求响应',
      access_token: 'Token',
      encrypt_request: '加密后的参数',
      decrypt_response: '解密结果',
      response: '原结果',
      test_action: '测试 API',
      requesting: '请求中...',
      plain_text: '纯文本',
      json: 'Json视图',
      selection_tip: '正在模拟测试：<span class="f-underline">{0}</span> 访问 <span class="f-underline">{1}</span> 提供的API服务',
      config_tip: '需要在 configuration.yml 中配置 evcs_service 才能访问 evcs-api 进行调试',
      evcs_internal_api_status: 'EVCS 为 ECMP 开放的内部接口服务 (evcs-api) {0}',
      evcs_internal_api_statuses: {
        correct: '访问正常，可以进行下方API功能测试',
        not_config: '没有配置，检查配置 configuration.yml 的 evcs_service',
        not_reachable: '无法访问，检查配置 configuration.yml 的 evcs_service',
        auth_error: '认证有误，检查配置 configuration.yml 的 evcs_service'
      },
      evcs_transfer_worker_status: 'ECMP 向 EVCS 的消息转发服务 (evcs_transfer_worker) {0}',
      evcs_message_worker_status: 'EVCS 接收 ECMP 的消息处理服务 (evcs_message_worker) {0}',
      worker_statuses: {
        down: '没有启动',
        up: '启动',
        healthy: '运行正常',
        sick: '无法正常运行'
      }
    },
    open_api_groups: {
      base: '基础',
      common_info: '公共信息',
      common_info_notification: '公共信息推送',
      service_info: '业务信息',
      service_info_notification: '业务信息推送',
      xiaoju: '小桔拓展接口',
      wanchengwanchong: '万城万充拓展接口',
      uniev: '联行拓展接口',
      guangzhou: '广州市级平台',
      other: '其他'
    },
    // 分组
    groups: {
      my_service: '我方提供的服务',
      evcs_service: '第三方提供的服务'
    },
    // 其他标签
    labels: {
      stations_count: '开放的电站数',
      today_order: '今日订单数',
      order: '近30天订单数',
      balance: '账户余额',
      station_updated_at: '最近主动请求时间',
      last_query_at: '最近被请求时间',
      format: '格式',
      ecmp_operator: '我方运营商'
    },
    btn: {
      sync_evcs_stations: '同步第三方充电站'
    },
    validates: {
      operator_id_length: '组织机构代码为9位字符'
    },
    communicate_config: {
      title: '入网配置',
      merchant_information: '第三方的入网信息',
      ecmp_information: 'ECMP的入网信息',
      merchant_name: '商家名称',
      server_request_location: '服务请求地址',
      message_key: '消息密钥',
      message_key_vector: '消息密钥向量',
      signature_key: '签名密钥',
      token_key: '运营商密钥',
      platform_users: '平台上的用户账号',
      opened_chargingStation: '开放的充电站',
      set_open_chargingStation: '设置开放的充电站',
      shared_all_station: '适用于所有电站',
      edit_information: '{0} 的入网信息',
      operator_communicate_config_tip: '{0}基于中电联协议的API服务的入网信息，该信息由{0}提供，只允许ECMP调用',
      ecmp_communicate_config_tip: 'ECMP基于中电联协议的API服务的入网信息，该信息由ECMP提供，只允许{0}调用',
      create_key: '生成随机密钥',
      station_sync_tip: '为了减轻同步压力，只同步新站 或者 已很久没有更新的站的信息 和 设备接口状态'
    },
    open_api: {
      service: '服务',
      third_party_API: '为ECMP开放的API',
      ecmp_party_API: '为第三方开放的API'
    },
    titles: {
      confirm_sync_station: '确认同步对方的充电站信息？',
      platform_info: '平台商信息',
      communication_setting: '协议配置',
      extra_info: '额外信息'
    },
    tip: {
      station_sync_completed: '更新充电站完成，请检查站信息 与 设备接口状态 是否已同步！',
      third_party_config_required: '当前平台入网信息配置完成后，需要等对方平台也配置完入网信息才能正常信息互联'
    }
  }
}
